export function groupByFieldGroup(fieldConfigs) {
  const seen = new Map();
  const groups = [];

  fieldConfigs.forEach((config) => {
    const hasGroup = !!(config.fieldGroup && String(config.fieldGroup).trim());
    const groupKey = hasGroup
      ? `group:${config.fieldGroup}`
      : `field:${config.fieldKey}`;
    const groupLabel = hasGroup ? config.fieldGroup : config.fieldGroup || config.label || "";

    if (!seen.has(groupKey)) {
      const group = { groupKey, groupLabel, fields: [] };
      seen.set(groupKey, group);
      groups.push(group);
    }

    seen.get(groupKey).fields.push(config);
  });
  return groups;
}
